import React from "react";
import { Provider } from "react-redux";
import { Router, Route, Switch, BrowserRouter } from "react-router-dom";
import { createBrowserHistory } from "history";
import { PersistGate } from "redux-persist/integration/react";
//redux store
import { store, persistor } from "./store/index";
import requireAuth from "./utils/requiresAuth";

//pages
import Landing from "./pages/Landing/Landing";
import Login from "./pages/Auth/Login";
import SignUp from "./pages/Auth/SignUp";
import Header from "./layout/header";
import Footer from "./layout/footer";
import Results from "./pages/Results/Results";
import Bookings from "./pages/Bookings/Bookings";
import LostPage from "./pages/404/LostPage";

import SuccessSnackbar from "./components/Snackbar/success";
import ErrorSnackbar from "./components/Snackbar/error";
import PrivacyPolicy from "./pages/FooterPages/PrivacyPolicy";
import CookiePolicy from "./pages/FooterPages/CookiePolicy";
// import renderIf from "render-if";

export const hist = createBrowserHistory();

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SuccessSnackbar />
        <ErrorSnackbar />
        <Router history={hist}>
          <Header />
          <BrowserRouter>
            <Switch>
              <Route exact path="/" component={Landing} />
              <Route login path="/login" component={Login} />
              <Route signup path="/signup" component={SignUp} />
              <Route path="/landing" component={Landing} />
              <Route path="/results" component={requireAuth(Results)} />
              <Route
                path="/bookings/:id/:name/"
                component={requireAuth(Bookings)}
              />
              <Route path="/hairQ/privacy-policy" component={PrivacyPolicy} />
              <Route path="/hairQ/cookie-policy" component={CookiePolicy} />
              <Route path="*" component={LostPage} />
              {/* <Redirect from="/" to="/login" /> */}
            </Switch>
          </BrowserRouter>
          <Footer />
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
